import Icon, { IconProps } from './Icon';

import ThumbsUpIcon from '../../../assets/icons/thumbs-up.svg?react';

const ThumbsUp: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <ThumbsUpIcon />
    </Icon>
  );
};

export default ThumbsUp;
